module.exports = __webpack_public_path__ + "img/8.871972e0.jpg";